/**
 * Темы оформления: перечень и проверка значения.
 *
 * Тема — настройка пользователя, она хранится на сервере (uiPrefs.theme)
 * и одинакова в вебе и приложении. Цвета у каждого клиента свои: в вебе —
 * styles/tokens.css, в приложении — порождённый из них src/theme/themes.ts.
 *
 * SYSTEM — не тема, а режим «как в операционной системе»: светлая или
 * тёмная по её настройке.
 */

export const THEMES = [
  "LIGHT",
  "DARK",
  "SEPIA",
  "MIDNIGHT",
  "CONTRAST",
  "RED",
  "GREEN",
  "LILAC",
  "LAVENDER",
  "POWDER",
  "ACID",
  "BLACK",
] as const;
export type NamedTheme = (typeof THEMES)[number];
export type Theme = NamedTheme | "SYSTEM";

export function isTheme(value: unknown): value is Theme {
  return value === "SYSTEM" || (THEMES as readonly unknown[]).includes(value);
}

/** Подписи тем — одни для веба и приложения. */
export const THEME_LABELS: Record<Theme, string> = {
  SYSTEM: "Как в системе",
  LIGHT: "Светлая",
  DARK: "Тёмная",
  SEPIA: "Тёплая",
  MIDNIGHT: "Полночь",
  CONTRAST: "Контрастная",
  RED: "Красная",
  GREEN: "Зелёная",
  LILAC: "Сиреневая",
  LAVENDER: "Лавандовая",
  POWDER: "Розовая пудра",
  ACID: "Кислотный кошмар",
  BLACK: "Чёрная",
};
